
import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for AccountsRoyalty Action/Mutation Types. Use it in   accounts/actions.js, accounts/mutations.js and the Vuex Host Component 
export const AccountsRoyaltyData = createActionTypeModel('AccountsRoyaltyData');
export const AccountsList = createActionTypeModel('AccountsList');
export const AccountsDetails = createActionTypeModel('AccountsDetails');
export const AccountsDetailsItems = createActionTypeModel("AccountsDetailsItems");
export const AccountsRelatedContacts = createActionTypeModel('AccountsRelatedContacts');
export const RoyaltyAccountsMainContacts = createActionTypeModel('RoyaltyAccountsMainContacts');
export const RoyaltyAccountsStatements = createActionTypeModel('RoyaltyAccountsStatements');
export const RoyaltyAccountsBalances = createActionTypeModel('RoyaltyAccountsBalances');
export const RoyaltyAccountsPayments = createActionTypeModel('RoyaltyAccountsPayments');
export const RoyaltyAccountsContracts = createActionTypeModel('RoyaltyAccountsContracts');
export const RoyaltyExternalUser = createActionTypeModel('RoyaltyExternalUser');
export const RoyaltyAccountsMechanicalContract = createActionTypeModel('RoyaltyAccountsMechanicalContract');
export const SET_ROYALTY_ACCOUNT_FILES = "SET_ROYALTY_ACCOUNT_FILES";
export const INSERT_ROYALTY_ACCOUNT_BALANCE = "INSERT_ROYALTY_ACCOUNT_BALANCE";
export const SET_ROYALTY_ACCOUNT_BALANCE = "SET_ROYALTY_ACCOUNT_BALANCE";